<template>
  <a-modal :title="modal.title" :visible="modal.visible" :confirm-loading="modal.confirmLoading" @ok="submit"
           @cancel="hide">
    <a-form :form="form">
      <a-form-item label="Strategy Identifier">
        <a-input v-decorator="['name',{rules:[{required:true,message:'Strategy Identifiercannot be empty'}]}]"></a-input>
      </a-form-item>
      <a-form-item label="StrategyDescription">
        <a-input v-decorator="['intro',{rules:[{required:true,message:'StrategyDescriptioncannot be empty'}]}]"></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import {addRiskStrategy, copyRiskStrategy} from "@/webpublicapi/risk";

export default {
  name: 'RuleEditModal',
  data() {
    return {
      modal: {title: '', visible: false, confirmLoading: false},
      form: this.$form.createForm(this),
      model: {id: undefined}
    }
  },
  methods: {
    showAdd() {
      this.modal.visible = true
      this.modal.title = 'Create Strategy'
    },
    showCopy(id) {
      this.modal.visible = true
      this.modal.title = 'Copy Strategy'
      this.model.id = id
    },
    hide() {
      this.modal = {title: '', visible: false, confirmLoading: false}
      this.form.resetFields()
      this.model = {id: undefined}
    },
    submit() {
      this.form.validateFields((errors, values) => {
        if (!errors) {
          this.modal.confirmLoading = true;
          (this.model.id ? copyRiskStrategy(Object.assign({}, this.model, values)) : addRiskStrategy(Object.assign({}, values))).then(({code}) => {
            if (code === 1000) {
              this.$message.success(this.$t('success'))
              this.hide()
              this.$emit('success')
            } else {
              return Promise.reject('')
            }
          }).catch(() => {
            this.$message.error('ActionFailed')
            this.modal.confirmLoading = false
          })
        }
      })
    }
  }
}
</script>